import { computed, effect, inject, Injectable } from '@angular/core';
import { updatePrimaryPalette } from '@primeuix/themes';
import { DEFAULT_DU_PRIMARY, DU_PALETTES, DuPrimary } from '../../../../public/theme/palettes';
import { LocalStorageService } from './local-storage.service';

export type ThemePreference = {
  primaryColor: DuPrimary;
  darkMode: boolean;
};

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly storageService = inject(LocalStorageService);

  readonly themePreference = this.storageService.signal<ThemePreference>('theme', {
    primaryColor: DEFAULT_DU_PRIMARY,
    darkMode: false,
  });

  readonly primaryColor = computed(() => this.themePreference().primaryColor);
  readonly darkMode = computed(() => this.themePreference().darkMode);

  constructor() {
    if (!DU_PALETTES[this.primaryColor()]) {
      this.themePreference.update((p) => ({ ...p, primaryColor: DEFAULT_DU_PRIMARY }));
    }

    effect(() => updatePrimaryPalette(DU_PALETTES[this.primaryColor()]));
    effect(() => document.documentElement.classList.toggle('p-dark', this.darkMode()));
  }

  setPrimaryColor(color: DuPrimary): void {
    this.themePreference.update((p) => ({ ...p, primaryColor: color }));
  }

  setDarkMode(dark: boolean): void {
    this.themePreference.update((p) => ({ ...p, darkMode: dark }));
  }
}
